module.exports = __webpack_public_path__ + "static/media/airbnb.4c1cc62f.png";